import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const ServiceHero = () => {
  const handleSchedulePickup = () => {
    window.location.href = '/pickup-scheduling';
  };

  const handleViewPricing = () => {
    const pricingSection = document.getElementById('pricing-section');
    if (pricingSection) {
      pricingSection?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const stats = [
    { number: '10,000+', label: 'Happy Customers', icon: 'Users' },
    { number: '50,000+', label: 'Garments Cleaned', icon: 'Shirt' },
    { number: '99.8%', label: 'On-Time Delivery', icon: 'Clock' },
    { number: '15+', label: 'Service Types', icon: 'Package' }
  ];

  return (
    <div className="relative bg-primary py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <Image
          src="/assets/images/servies.jpg"
          alt="Premium laundry facility with modern equipment and clean environment"
          className="w-full h-full object-cover opacity-60"
        />
        <div className="absolute inset-0 bg-primary/30"></div>
      </div>
      
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-60 h-60 bg-white/20 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10">
        <div className="text-center space-y-8">
          {/* Hero Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <div className="inline-flex items-center space-x-2 bg-white/20 text-white px-6 py-3 rounded-full text-sm font-medium border border-white/30">
              <Icon name="Sparkles" size={16} />
              <span>Premium Laundry Services</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-bold text-white leading-tight">
              Professional Care for
              <span className="block text-accent">Every Garment</span>
            </h1>

            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
              From everyday essentials to delicate fabrics, our expert team provides comprehensive laundry solutions with guaranteed quality and convenient pickup & delivery across Coimbatore.
            </p>
          </motion.div>

          {/* CTA Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-6"
          >
            <Button
              variant="default"
              size="lg"
              onClick={handleSchedulePickup}
              iconName="Calendar"
              iconPosition="right"
              className="bg-accent hover:bg-accent/90 text-white border-0 transition-all duration-300 hover:shadow-elevation-3 hover:scale-105"
            >
              Schedule Pickup Now
            </Button>
            <Button
              variant="outline"
              size="lg"
              onClick={handleViewPricing}
              iconName="Eye"
              iconPosition="left"
              className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:border-white/50 transition-all duration-300"
            >
              View Pricing
            </Button>
          </motion.div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="grid grid-cols-2 md:grid-cols-4 gap-8 pt-16"
          >
            {stats?.map((stat, index) => (
              <motion.div
                key={stat?.label}
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: 0.5 + index * 0.1 }}
                className="text-center space-y-3"
              >
                <div className="w-16 h-16 bg-white/10 rounded-2xl shadow-elevation-1 mx-auto flex items-center justify-center border border-white/20">
                  <Icon name={stat?.icon} size={24} color="white" />
                </div>
                <div>
                  <div className="text-3xl font-bold text-white">{stat?.number}</div>
                  <div className="text-sm text-white/80">{stat?.label}</div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default ServiceHero;